export const log = (...error) => {
  // eslint-disable-next-line no-console
  console.error('🙈 ', ...error)
}
